import React from 'react';
import { Icon, Typography } from "../ecosystem";

const FavoriteDrRating = ({
    rating,
    count
}) => {

    return (rating &&
        <Typography tag="div">
            <Icon name="star" color="$color-primary-b2" /> {rating} {count ? `(${count} reviews)` : ''}
        </Typography>
    );
}

export default FavoriteDrRating;
